// React Imports
import type { SVGAttributes } from 'react'

const WorkOS = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width='1.16667em'
      height='1em'
      fill='#6363F1'
      viewBox='0 0 35 30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M0 14.9831C0 15.6401 0.175001 16.297 0.513335 16.8618L6.65003 27.3615C7.28003 28.4333 8.2367 29.3093 9.42671 29.7011C11.7717 30.4733 14.1984 29.4822 15.3534 27.4998L16.8351 24.9642L10.99 14.9831L17.1617 4.41426L18.6434 1.87865C19.0867 1.11797 19.6817 0.495595 20.3818 0H19.7401H10.8617C9.19337 0 7.65337 0.875936 6.82503 2.30509L0.513335 13.1045C0.175001 13.6692 0 14.3262 0 14.9831Z'></path>
      <path d='M34.9999 14.9831C34.9999 14.3261 34.8249 13.6692 34.4866 13.1044L28.2682 2.46641C27.1132 0.495551 24.6865 -0.49564 22.3415 0.265041C21.1515 0.656907 20.1949 1.53284 19.5649 2.60471L18.1648 4.99048L24.0099 14.9831L17.8382 25.5519L16.3565 28.0875C15.9132 28.8367 15.3182 29.4706 14.6182 29.9662H15.2598H24.1382C25.8065 29.9662 27.3466 29.0902 28.1749 27.6611L34.4866 16.8617C34.8249 16.297 34.9999 15.64 34.9999 14.9831Z'></path>
    </svg>
  )
}

export default WorkOS
